import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export const useGet2FA = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(() => api.base
        .post('/api/user/get2fa')
        .then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { get2FA: mutateAsync, isLoading };
};
